<template>
  <div v-if="isEntityOwner && !file.user?.can?.transcodeVideo && file.streamable && file.streamable_until" class=" mt-2 mb-5 bg-blue/20 rounded p-2 flex flex-col gap-2 items-center border border-blue/75">
    <p class="text-white text-sm text-center">Complimentary 90-Day Streaming for this video ends on <strong>{{$dayjs(file.streamable_until).format('LL')}} at {{$dayjs(file.streamable_until).format('LT')}}</strong></p>
    <u-button color="blue" block @click="openVideoUpsellModal({context: VIDEO_UPSELL_CONTEXTS.fileDetailStreamingExpiration})">View Plans</u-button>
  </div>
</template>

<script setup>
  const {openVideoUpsellModal} = useCommonModals();
  const props = defineProps({
    file: {
      type: Object,
      required: true
    }
  })

  const isEntityOwner = computed(() => useUserContext({entity: props.file}).isEntityOwner.value);
</script>
